import React from 'react'
import cn from 'classnames'
import { useRouter } from 'next/router'

import { ComponentLinkTargetTab, TypeComponentLink } from '@lib/types'
import { ExternalLink, useLinkStyleFromTheme } from '@ui-lib/link'
import { ButtonCtaProps } from '@ui-lib/button'
import styles from './component-link.module.scss'
import { CtaArrow } from '@ui-lib/icons/cta-arrow'
import { getLinkColorClassName } from '@components/item/link/link-color'
import { useIsSectionThemeDark } from '@contexts/section-theme-context'
import { composeUrl } from '@lib/utils/url'

export interface ComponentLinkProps extends Omit<ButtonCtaProps, 'onClick' | 'text'> {
  targetLink: TypeComponentLink
  isEmbedded?: boolean
  className?: string
}

export const ComponentLink: React.FC<ComponentLinkProps> = (props) => {
  const { targetLink, isEmbedded, className } = props
  const {
    embeddedEntryText,
    relationToUrl,
    title,
    targetTab,
    targetUrl,
    showArrow,
    colorStyle,
    appendCurrentQueryParams,
  } = targetLink.fields
  const linkStyle = useLinkStyleFromTheme()
  const isDarkThemeSection = useIsSectionThemeDark()
  const colorStyleClassname = getLinkColorClassName(colorStyle)
  const { query } = useRouter()

  const href = appendCurrentQueryParams ? composeUrl(targetUrl, query) : targetUrl

  return (
    <ExternalLink
      href={href}
      target={targetTab === ComponentLinkTargetTab.Blank ? '_blank' : '_self'}
      rel={relationToUrl?.join(' ')}
      title={title}
      className={cn(
        styles.externalLink,
        isEmbedded && linkStyle,
        !isDarkThemeSection && colorStyleClassname,
        className
      )}
    >
      {embeddedEntryText}
      {showArrow && (
        <span className={styles.arrow} aria-hidden={true}>
          <CtaArrow />
        </span>
      )}
    </ExternalLink>
  )
}
